import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "vision", label: "Vision" },
  { id: "technologie", label: "Technologie" },
  { id: "investment", label: "Marktpotenzial" },
  { id: "kontakt", label: "Partner werden" },
];

const Header = ({ activeSection }) => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/55 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="logo-link"
          className="font-heading text-xl md:text-2xl font-semibold tracking-[0.04em] flex items-center gap-2.5"
        >
          <span className="inline-block w-2 h-2 bg-[#c88a53]" aria-hidden />
          MONOWOOD
        </a>

        <nav className="hidden md:flex items-center gap-8 lg:gap-10">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-link-${item.id}`}
              className={`text-sm tracking-wide transition-colors ${
                activeSection === item.id
                  ? "text-[#c88a53]"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="#kontakt"
            data-testid="header-cta"
            className="btn-primary text-sm"
          >
            Pitch Booklet
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/90">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.id}`}
                className="text-base text-white/80 hover:text-[#c88a53]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              data-testid="mobile-header-cta"
              className="btn-primary text-sm w-fit mt-2"
            >
              Pitch Booklet
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
